import { render, staticRenderFns } from "./AllUserLeads.vue?vue&type=template&id=c9fe0b52&scoped=true&lang=pug"
import script from "./AllUserLeads.vue?vue&type=script&lang=js"
export * from "./AllUserLeads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9fe0b52",
  null
  
)

export default component.exports